module.exports = __webpack_public_path__ + "img/src/components/ContactForm/mail.png?0f40ff46";